<template>
  <v-container style="text-align: center;">
    <h1 style="text-align: center; text-transform: uppercase;">Order Complete!</h1>

    <p>You will receive your stickers in 2-5 business days.</p>

    <p>An order confirmation email is on the way.</p>

    <p>Thank you for your purchase!</p>

    <p @click="home" class="link">Continue browsing</p>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data: () => ({
    error: "",
    stickers: null
  }),
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    home() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
